import React from "react";

/**
 * Section header with optional action button
 *
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.action - Action component (like a button)
 * @param {string} props.className - Additional class names
 * @returns {JSX.Element}
 */
const SectionHeader = ({ title, action, className = "" }) => {
  return (
    <div className={`flex justify-between items-center mb-4 ${className}`}>
      <h2 className="text-lg font-medium text-gray-900">{title}</h2>
      {action}
    </div>
  );
};

export default SectionHeader;
